import { render } from "./NetworkInfo.vue?vue&type=template&id=a127e554&scoped=true"
import script from "./NetworkInfo.vue?vue&type=script&lang=js"
export * from "./NetworkInfo.vue?vue&type=script&lang=js"

import "./NetworkInfo.vue?vue&type=style&index=0&id=a127e554&scoped=true&lang=css"

import exportComponent from "/Users/einarbragi/Code/hlada.is/hlada-vue-mapbox/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a127e554"]])

export default __exports__